import axios from "axios";
import { safeJsonParse } from '../utils/jsonUtils'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,

});

instance.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem("accessToken");
    let accessToken = safeJsonParse(token);
    config.headers.authorization = accessToken;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    const { data } = response;
    // if (data.notify) {
    //   const customId = data.message ?? "success";
    //   toast.success(data.message ?? "success", { toastId: customId });
    // }
    return response;
  },
  (error) => {
    const { response } = error;

    // if (response.status === 401)
    //   toast.error(`(401) ${response?.data?.message}`);
    // else toast.error(response?.data?.message);

    if (response?.status === 401) {
      localStorage.clear();
      window.location.replace(`${window.location.origin}/`);
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export default instance;
